import { StyleSheet, css } from 'aphrodite'
import type React from 'react'

interface OnboardingStepWelcomeProps {
  onNext: () => void
}

const OnboardingStepWelcome: React.FC<OnboardingStepWelcomeProps> = ({
  onNext,
}) => (
  <div className={css(styles.centered)}>
    <img src="/truck.png" alt="Truck" className={css(styles.truckImg)} />
    <h2 className={css(styles.title)}>Welcome to DayDaCo!</h2>
    <p className={css(styles.subtitle)}>
      Let's set up your trucker profile so you can start finding delivery
      opportunities.
    </p>
    <div className={css(styles.checkList)}>
      <div className={css(styles.checkItem)}>
        <img
          src="/Checkmark.png"
          alt="Checkmark"
          className={css(styles.checkIcon)}
        />{' '}
        Create your profile
      </div>
      <div className={css(styles.checkItem)}>
        <img
          src="/Checkmark.png"
          alt="Checkmark"
          className={css(styles.checkIcon)}
        />{' '}
        Start Inviting
      </div>
    </div>
    <button className={css(styles.primaryButton)} onClick={onNext}>
      Get Started
    </button>
  </div>
)

const styles = StyleSheet.create({
  centered: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  truckImg: {
    width: 130,
    height: 130,
    objectFit: 'contain',
  },
  title: {
    fontSize: 28,
    fontWeight: 600,
    color: '#1F3A8A',
    margin: '16px 0 8px 0',
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 16,
    color: '#222',
    marginBottom: 32,
    textAlign: 'center',
  },
  checkList: {
    marginBottom: 32,
    maxWidth: 300,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'center',
  },
  checkItem: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    marginBottom: 12,
    color: '#222',
    width: '100%',
  },
  checkIcon: {
    width: 24,
    height: 24,
    marginRight: 12,
    verticalAlign: 'middle',
  },
  primaryButton: {
    background: '#2563EB',
    color: '#fff',
    border: 'none',
    borderRadius: 12,
    width: '100%',
    fontSize: 16,
    fontWeight: 600,
    marginTop: 24,
    cursor: 'pointer',
    height: 48,
    alignItems: 'center',
    justifyContent: 'center',
  },
})

export default OnboardingStepWelcome
